<ion-card>
  <ion-card-header>
    <ion-card-title>Csoporttagság-import</ion-card-title>
    <ion-card-subtitle>„Csoportba járó tanulók" lista beolvasása — duplikáció nélkül</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="ic-bevezeto">
      A csoportokba a tanulókat eddig kézzel, egyesével kellett bepipálni — pedig a lista
      letölthető abból a rendszerből, ahol a beosztás készül. Az import <b>két lépés</b>, és
      az első nem ír semmit: előbb megmutatja, mit talált, és csak azt hajtja végre, amit
      <b>csoportonként jóváhagysz</b>.
    </ion-note>

    <!-- 1. Fájl -->
    <div class="ic-lepes">
      <h3><span class="ic-szam">1</span> Fájl</h3>
      <input #fajlValaszto type="file" accept=".xlsx,.xls,.csv" hidden (change)="fajlValtozott($event)" />
      <div class="ic-fajlsor">
        <ion-button size="default" fill="outline" (click)="fajlValaszto.click()">
          <ion-icon slot="start" name="document-attach-outline"></ion-icon>
          {{ fajlNev ? 'Másik fájl' : 'Fájl kiválasztása' }}
        </ion-button>
        <span class="ic-fajl" *ngIf="fajlNev">{{ fajlNev }} — <b>{{ nyersSorok.length }}</b> sor</span>
        <span class="ic-fajl halvany" *ngIf="!fajlNev">Excel (.xlsx/.xls) vagy CSV</span>
      </div>
    </div>

    <!-- 2. Oszlopok -->
    <div class="ic-lepes" *ngIf="fejlecek.length">
      <h3><span class="ic-szam">2</span> Melyik oszlop mit jelent?</h3>
      <ion-note color="medium" class="ic-sugo">
        A szokásos elnevezéseket felismerjük, de a hozzárendelés látszik és átállítható —
        egy ismeretlen fejlécű export se legyen zsákutca. A <b>csoport</b> kötelező, a tanulót
        pedig <b>oktatási azonosítóval</b> vagy <b>névvel</b> lehet megadni; az azonosító az
        erősebb, mert egyértelmű.
      </ion-note>
      <div class="ic-sor">
        <ion-select label="Csoport *" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.csoport">
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Oktatási azonosító" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.oktazon">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Tanuló neve" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.nev">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Osztály (tájékoztató)" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.osztaly">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
      </div>
      <ion-button color="primary" [disabled]="!oszlop.csoport || elemzesFut" (click)="elemez()">
        <ion-icon slot="start" name="search-outline"></ion-icon>
        {{ elemzesFut ? 'Elemzés…' : 'Elemzés (' + kuldhetoSorok.length + ' sor)' }}
      </ion-button>
    </div>

    <!-- 3. Eredmény -->
    <div class="ic-lepes" *ngIf="elemzes">
      <h3><span class="ic-szam">3</span> Mit talált?</h3>

      <div class="ic-osszegzo">
        <div class="ic-kartya"><b>{{ elemzes.osszegzo.csoport }}</b><span>csoport a fájlban</span></div>
        <div class="ic-kartya figy" *ngIf="elemzes.osszegzo.uj_csoport">
          <b>{{ elemzes.osszegzo.uj_csoport }}</b><span>nem létezik</span>
        </div>
        <div class="ic-kartya ok"><b>{{ elemzes.osszegzo.felveheto }}</b><span>felvehető tagság</span></div>
        <div class="ic-kartya" *ngIf="elemzes.osszegzo.mar_tagja">
          <b>{{ elemzes.osszegzo.mar_tagja }}</b><span>már tagja</span>
        </div>
        <div class="ic-kartya" *ngIf="elemzes.osszegzo.ismetlodik">
          <b>{{ elemzes.osszegzo.ismetlodik }}</b><span>ismétlődik a fájlban</span>
        </div>
        <div class="ic-kartya baj" *ngIf="elemzes.osszegzo.hibas">
          <b>{{ elemzes.osszegzo.hibas }}</b><span>nem azonosítható</span>
        </div>
        <div class="ic-kartya figy" *ngIf="szinkron">
          <b>{{ vartLezaras }}</b><span>tagság zárulna le</span>
        </div>
      </div>

      <table class="ic-tabla">
        <thead>
          <tr>
            <th>Csoport a fájlban</th>
            <th>Állapot</th>
            <th>Mi legyen</th>
            <th class="szam">Bekerül</th>
            <th class="szam" *ngIf="szinkron">Kikerül</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let cs of elemzes.csoportok">
            <tr>
              <td><b>{{ cs.nev }}</b></td>
              <td>
                <span class="ic-jel ok" *ngIf="cs.letezo && !cs.elteroIrasmod">létezik</span>
                <span class="ic-jel figy" *ngIf="cs.letezo && cs.elteroIrasmod">
                  létezik más írásmóddal: <b>{{ cs.letezo.name }}</b>
                </span>
                <span class="ic-jel baj" *ngIf="!cs.letezo">nincs ilyen csoport</span>
                <div class="ic-hasonlo" *ngIf="!cs.letezo && cs.hasonlok?.length">
                  Hasonló nevű: <span *ngFor="let h of cs.hasonlok; let i = index">{{ i ? ', ' : '' }}{{ h.name }}</span>
                </div>
              </td>
              <td>
                <ion-select interface="popover" [ngModel]="dontes[kulcs(cs)]?.muvelet"
                            (ngModelChange)="muveletValt(cs, $event)">
                  <ion-select-option value="kihagy">— kihagyom —</ion-select-option>
                  <ion-select-option value="meglevo" *ngIf="cs.letezo || cs.hasonlok?.length">meglévő csoportba</ion-select-option>
                  <ion-select-option value="letrehoz">új csoport létrehozása</ion-select-option>
                </ion-select>
                <ion-select interface="popover" *ngIf="dontes[kulcs(cs)]?.muvelet === 'meglevo'"
                            [(ngModel)]="dontes[kulcs(cs)].cel_id" placeholder="melyikbe?">
                  <ion-select-option *ngIf="cs.letezo" [value]="cs.letezo.id">
                    {{ cs.letezo.name }} ({{ cs.letezo.ev }})
                  </ion-select-option>
                  <ion-select-option *ngFor="let h of cs.hasonlok" [value]="h.id">{{ h.name }} ({{ h.ev }})</ion-select-option>
                </ion-select>
              </td>
              <td class="szam">
                <b>{{ dontes[kulcs(cs)]?.muvelet === 'kihagy' ? 0 : cs.felveheto }}</b>
                <span class="ic-osszes">/ {{ cs.osszes }}</span>
              </td>
              <td class="szam" *ngIf="szinkron">
                <span *ngIf="cs.hibas" class="ic-jel baj" title="Van azonosíthatatlan sor – ennél a csoportnál nem zárunk le semmit.">nem zárjuk</span>
                <b *ngIf="!cs.hibas">{{ kikerulE(cs) }}</b>
              </td>
              <td class="ic-muvelet">
                <ion-button size="small" fill="clear" (click)="nyitott[kulcs(cs)] = !nyitott[kulcs(cs)]">
                  {{ nyitott[kulcs(cs)] ? 'Bezár' : 'Sorok' }}
                </ion-button>
              </td>
            </tr>
            <tr *ngIf="nyitott[kulcs(cs)]" class="ic-reszletek">
              <td [attr.colspan]="szinkron ? 6 : 5">
                <div class="ic-sorlista">
                  <div *ngFor="let r of cs.sorok" [class.gond]="r.allapot !== 'ok'">
                    <span class="ic-nev">{{ r.nev || r.megadott_azonosito || r.oktazon }}</span>
                    <span class="ic-halvany" *ngIf="r.osztaly">{{ r.osztaly }}</span>
                    <span class="ic-allapot">{{ allapotSzoveg(r.allapot) }}</span>
                  </div>
                  <ng-container *ngIf="szinkron && kikerulE(cs)">
                    <div *ngFor="let k of cs.kikerulok" class="kikerul">
                      <span class="ic-nev">{{ k.nev || k.oktazon }}</span>
                      <span class="ic-allapot">nincs a fájlban — a tagsága lezárul</span>
                    </div>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <ion-note color="medium" class="ic-sugo">
        <b>Duplikáció nem keletkezhet:</b> aki már tagja a csoportnak, kimarad; a fájlban
        ismétlődő sor egyszer megy be; az azonos nevű, de máshogy írt csoportból pedig nem
        lesz másodpéldány — a rendszer felkínálja a meglévőt. Csoportot csak akkor hoz létre,
        ha itt kifejezetten azt kéred.
      </ion-note>

      <label class="ic-szinkron">
        <input type="checkbox" [checked]="szinkron" (change)="szinkron = !szinkron" />
        <span><b>Szinkron:</b> a fájl a csoportok teljes névsora — aki nincs benne, annak a tagsága lezárul</span>
      </label>
      <ion-note color="medium" class="ic-sugo" *ngIf="szinkron">
        Alapból az import <b>csak hozzáad</b>: aki a KRÉTÁ-ban átkerült egy másik csoportba, az
        nálunk mindkét csoport névsorában benne marad. Szinkron módban a fájlban szereplő
        csoportoknál <b>aki nincs a fájlban, annak a tagsága lezárul</b> — a tegnapi nappal,
        tehát a mai naptól nem szerepel a csoport névsorában, a korábbi órák névsora és a
        beírt jegyek, hiányzások viszont <b>megmaradnak</b> (nem törlünk semmit).
        <b>Csak a fájlban szereplő csoportokhoz nyúlunk</b>, a többihez nem. Ha egy csoportnál
        akár egy sor is <b>nem azonosítható</b> (pl. a tanuló még nincs felvéve nálunk), annál a
        csoportnál <b>semmit nem zárunk le</b> — egy hiányos névsor alapján olyat is kivennénk,
        aki valójában jár a csoportba. A kikerülők nevét a „Sorok" gomb mutatja meg.
      </ion-note>

      <div class="ic-lab">
        <div class="ic-lab-szoveg">
          <b>{{ vartUjCsoport }}</b> új csoport, <b>{{ vartUjTagsag }}</b> új tagság<ng-container
            *ngIf="szinkron">, várhatóan <b>{{ vartLezaras }}</b> lezárt tagság</ng-container>.
        </div>
        <ion-button color="primary" [disabled]="fut || !vegrehajthato" (click)="vegrehajt()">
          <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
          {{ fut ? 'Import…' : 'Import végrehajtása' }}
        </ion-button>
      </div>
    </div>

    <!-- 4. Eredmény -->
    <div class="ic-lepes" *ngIf="eredmeny">
      <h3><span class="ic-szam">✓</span> Kész</h3>
      <ion-note color="success" style="display:block">
        <b>{{ eredmeny.csoport_letrehozva }}</b> új csoport,
        <b>{{ eredmeny.tagsag_uj }}</b> új tagság,
        <ng-container *ngIf="eredmeny.szinkron"><b>{{ eredmeny.tagsag_lezarva }}</b> tagság lezárva,</ng-container>
        <b>{{ eredmeny.kihagyva }}</b> sor kihagyva.
      </ion-note>
      <table class="ic-tabla ic-eredmeny" *ngIf="eredmenyCsoportok.length">
        <thead>
          <tr>
            <th>Csoport</th>
            <th class="szam">Új tagság</th>
            <th class="szam" *ngIf="eredmeny.szinkron">Lezárt tagság</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of eredmenyCsoportok">
            <td>
              <b>{{ c.nev }}</b>
              <div class="ic-hasonlo" *ngIf="c.szinkron">{{ c.szinkron }}</div>
            </td>
            <td class="szam">{{ c.uj_tagsag }}</td>
            <td class="szam" *ngIf="eredmeny.szinkron">{{ c.lezart_tagsag }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ion-card-content>
</ion-card>
